const config = {
    get apiUrl(): string{
        const host = process.env.REACT_APP_API_HOST || 'http://localhost';
        const port = process.env.REACT_APP_API_PORT || '8000';
        const path = process.env.REACT_APP_API_PATH || '/api/v1';
        return host + (port ? `:${port}` : '') + (path ?? '');
    },
    get languages(): string[]{
        return ['en', 'ru'];
    }
};

export default config;